<div class="header-Container">
  <div class="row">
    <div class="col-md-6 col-sm-12">
      @if (standardCartDetails?.code === '' || standardCartDetails?.code === undefined) {
        <h4 class="prodCat-title"
          >
        New Reservation</h4>
      } @else {
        <h4 class="prodCat-title">Reservation # {{standardCartDetails?.code}}</h4>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-md-7 col-sm-12">
      <span class="activeSeasonId">
        {{activeSeasonId}} {{'selectVaccines.season'|cxTranslate}}
      </span>
      @if (reservationStatus !== '' && reservationStatus !==undefined) {
        <span class="activeSeasonId">
          | {{reservationStatus}}
        </span>
      }
      @if (reservationStatus !== '' && reservationStatus !==undefined) {
        <span>
          @if (reservationStatus === 'Confirmed') {
            <img class="mb-1" src="/icons/confirm.png"
              alt="status" />
          }
          @if (reservationStatus === 'Partially confirmed') {
            <img class="mb-1"
              src="/icons/part-confirm.png" alt="status" />
          }
          @if (reservationStatus === 'Not confirmed') {
            <img class="mb-1" src="/icons/not-confirm.png"
              alt="status" />
          }
        </span>
      }
    </div>
    <div class="col-md-5 col-sm-12 bc-Dash-Div no-print">
      <a (click)='backToDashBoard()'>
        <img src='/icons/{{baseSiteId}}/chevron-left_green.svg' class="svg-Images" alt="left">
      {{'selectVaccines.back_to_db'|cxTranslate}}</a>&nbsp;&nbsp;
      <a (click)="downloadExcel()" class="excel-download mr-1"><img class="mr-1"
        src="/icons/{{baseSiteId}}/excel_new.png" alt="XLS" />
      <span>{{ "orderDetail.xls" | cxTranslate }}</span></a>&nbsp;&nbsp;
      <a class="print mr-3" (click)="OnFluPrint()">
        <img src="/icons/{{baseSiteId}}/print.svg" class="svg-Images" alt="print">
      {{'selectVaccines.print'|cxTranslate}}</a>
    </div>
  </div>
</div>

@if (editReservation || cancelReservation) {
  <div class="confirmation-container" [style.display]="isConfirmSuccOpen ? 'block' : 'none'"
    >
    <div class="editCancelConfirmationPopup">
      <div>
        <div class="confirmation-success-box">
          <div class="row margin0" role="dialog" aria-labelledby="editConfrimationSucc"
            aria-describedby="editConfrimationSuccDescrip">
            <div class="col-xs-10 col-md-11 nopadding-nomargin">
              <p class="alertBanner" role="heading" aria-level="2">
                <img src="/icons/{{baseSiteId}}/confirmation-positive-green.png" alt="success"
                  class="acc-close-button">
                @if (editReservation) {
                  <span class="confirm-text">Your reservation has been updated.</span>
                }
                @if (cancelReservation) {
                  <span class="confirm-text">Your reservation has been cancelled.</span>
                }
              </p>
              <p class="sub-text" role="heading" aria-level="2">
                @if (editReservation) {
                  <span class="sanofiAlertComponent_text">
                    Shipping notifications will be sent to the reservation contact.
                  </span>
                }
              </p>
            </div>
            <div class="col-xs-2 col-md-1 alert-close-confirmpg">
              <p class="close-banner" (click)="closeConfirmBanner()"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div class="container-fluid" id="main-Container">
  <div class="row verify-payment" id="left-right-sections">
    <section class="col-lg-8 col-md-12 col-sm-12 col-xs-12 verifypayment-leftsection float-left">

      <!--Total Esitimation for small screens to move left side on top-->

      <section class="shipto-products">
        <div class="row">
          <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 ver-pay-head">

            <div class="title-new verifypayment-Title row">
              <div class="cold-md-1"><img class="locationicon-align"
              src="/icons/{{baseSiteId}}/location.svg" alt="loc" /></div>
              <div class="col-md-11 col-xs-6 col-sm-6"><span>{{selectedLocation}}</span></div>
            </div>
          </div>
          <div class="col-xs-5 col-lg-5 col-md-5 col-sm-5 label-location">
            <table class="location-table col-12">
              <tr class="row">
                <td class="fw-bold col-8 text-right">Reservation #:</td>
                <td class="fw-bold col-4 p0 wrap-Text">{{standardCartDetails?.code}}</td>
              </tr>
              <tr class="row">
                <td class="fw-bold col-8 text-right">PO #:</td>
                <td class="fw-bold col-4 p0 wrap-Text">
                  {{standardCartDetails?.purchaseOrderNumber!=''?standardCartDetails?.purchaseOrderNumber:standardCartDetails?.code}}
                </td>
              </tr>
            </table>
          </div>

        </div>

        <div class="row add-detailsflu">
          <div class="col-md-3 col-sm-12 pr0 ship-to">
            <h5 class="h5-title">Ship to</h5>
            <div class="details">
              <p>Account #:{{shippingAddressOfLocation?.accountNumber}}</p>
              <p>{{ shippingAddressOfLocation?.facilityName ? shippingAddressOfLocation?.facilityName + ',' : "" }} {{
                shippingAddressOfLocation?.facilityName2
              ? shippingAddressOfLocation?.facilityName2 + ',' : "" }}</p>
              <p>{{ shippingAddressOfLocation?.line1 ? shippingAddressOfLocation?.line1 + ',' : "" }}
              {{ shippingAddressOfLocation?.line2 ? shippingAddressOfLocation?.line2 + ', ' : "" }}</p>
              <p>{{ shippingAddressOfLocation?.town ? shippingAddressOfLocation?.town + ',' : "" }}</p>
              <p>{{ shippingAddressOfLocation?.region?.name ? shippingAddressOfLocation?.region?.name + ', ': ""}}
                {{shippingAddressOfLocation?.postalCode ?
              shippingAddressOfLocation?.postalCode : ""}}</p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 pr0 ship-to">

            @if (standardCartDetails?.attention) {
              <h5 class="h5-title">Attention</h5>
            }
            <div class="details wrap-Text">{{standardCartDetails?.attention}}</div>
          </div>
          <div class="col-md-5 col-sm-12">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="ff-bold">Subtotal</th>
                    <th class="fw-normal">{{subTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</th>
                  </tr>
                </thead>
                <tbody>
                  @if (salesTax >0) {
                    <tr>
                      <td>Sales tax</td>
                      <td>{{salesTax | currency : 'USD' : 'symbol' : '1.2-2' }}</td>
                    </tr>
                  }
                  <tr class="bg-color bgborder">
                    <td>Excise tax <sup>1</sup></td>
                    <td>{{exciseTax | currency : 'USD' : 'symbol' : '1.2-2' }}</td>
                  </tr>
                  <tr>
                    <td>Direct Savings</td>
                    <td class="green">-{{getPositveNumber(directSavings) | currency : 'USD' : 'symbol' : '1.2-2' }}</td>
                  </tr>
                  <tr>
                    <td>Online Savings <sup>2</sup></td>
                    <td class="green">-{{getPositveNumber(onlineSavings) | currency : 'USD' : 'symbol' : '1.2-2' }}</td>
                  </tr>
                  <tr class="bg-color bgborder">
                    <td class="ff-bold light-color pt1">Total</td>
                    <!--To be calculated as discussed with Manoj on 28sep23-->
                    <td class="light-color pt1">{{(subTotal + exciseTax + salesTax + directSavings + onlineSavings)| currency :
                    'USD' : 'symbol' : '1.2-2' }}</td>
                  </tr>
                  <tr class="prompt-pay">
                    <td>Prompt Pay discount <sup>3</sup></td>
                    <td class="green">-{{getPositveNumber(promptPayDiscount) | currency : 'USD' : 'symbol' : '1.2-2' }}
                    </td>
                  </tr>
                  <tr class="bg-color savings">
                    <td class="ff-bold light-color pt1">Total with Prompt Pay</td>
                    <td class="ff-bold light-color pt1">{{(totalWithPromptDisc + promptPayDiscount)| currency : 'USD' :
                      'symbol' : '1.2-2' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        @if (!cancelReservation) {
          <div class="sanofi-accordion existing-doses">
            <div class="panel-group">
              <div class="panel panel-default">
                <div id="pdp-list1" class="panel-collapse collapse in">
                  @for (productEntry of productEntries; track productEntry; let i = $index) {
                    <div class="panel-body">
                      <ul class="checkout-details">
                        <li>
                          <div class="row row-20">
                            <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 data-pad">
                              <div class="checkout-data">
                                <a (click)="productDetails(productEntry?.product)" class="cart_title">
                                  <div class="fluprodlistimg">
                                    <div class="flu-dashboard-prod-img">
                                      @if (productEntry?.product?.images !== undefined) {
                                        <img
                                          src="{{getImage(productEntry.product?.images,'thumbnail')}}" alt=""
                                          title="{{productEntry?.product?.variantOptions[0].description}}" />
                                      } @else {
                                        <img [src]="fallbackImage" alt=""
                                          title="{{productEntry?.product?.variantOptions[0].description}}" />
                                      }
                                    </div>
                                  </div>
                                  <div>
                                    @for (itm of productEntry?.product?.variantOptions; track itm) {
                                      @if (productEntry?.product?.code==itm.code) {
                                        <div>
                                          <h2 class="prod-title" [innerHTML]="itm?.description"></h2>
                                        </div>
                                      }
                                    }
                                  </div>
                                </a>
                              </div>
                              @if (productEntry?.product?.ageIndication) {
                                <div class="row age-indication mt-2">
                                  <span>{{productEntry?.product?.ageIndication}}</span>
                                </div>
                              }
                              <div class="ndc-div">
                                @if (productEntry?.product?.ndcCode) {
                                  <span class="ndcCode">
                                  {{productEntry?.product?.ndcCode}}</span>
                                }
                              </div>
                              <div class="row verify-step-influenza mt-2">
                                <div class="col-md-7 col-sm-7 p0 pl15">
                                  <p class="">
                                    <span>{{productEntry?.product?.code}}</span>
                                    @if (productEntry?.product?.manufacturer) {
                                      <span>|
                                      {{productEntry?.product?.manufacturer}}</span>
                                    }
                                  </p>
                                </div>
                                @if (productEntry?.contractName) {
                                  <div class="col-xs-12 col-md-4 col-sm-4 col-lg-4 sortBy-select p0 pl15"
                                    >
                                    <div class="sanofi-dropdown-sec btn-group" id="sort-by">
                                      <p class="btn-title">Contract group</p>
                                      <p class="rb_f14">{{productEntry?.contractName}}</p>
                                    </div>
                                  </div>
                                }
                              </div>
                              @if (productEntry?.product?.orderable==true && productEntry?.product?.soldOut==false && productEntry?.product?.shipNow=='ON') {
                                <div class="row verify-step-influenza mt-2"
                                  >
                                  @if (editReservation) {
                                    <div class="col-md-12 col-sm-12 p0 pl15">
                                      @if (productEntry?.estimatedDeliveryDate && productEntry?.estimatedDeliveryDate!='') {
                                        <p
                                          >
                                          <span>Estimated ship date</span>
                                          <span class="req-date">{{productEntry?.estimatedDeliveryDate | slice:0:10 | date:
                                          "MM/dd/yyyy"}}</span>
                                        </p>
                                      } @else {
                                        <p>
                                          <span>Estimated ship date</span>
                                          <span class="req-date">TBD</span>
                                        </p>
                                      }
                                    </div>
                                  } @else {
                                    <div class="col-md-12 col-sm-12 p0 pl15">
                                      <p>
                                        <span>Estimated ship date</span>
                                        <span class="req-date">{{productEntry?.estimatedDeliveryDate | slice:0:10 | date:
                                        "MM/dd/yyyy"}}</span>
                                      </p>
                                    </div>
                                  }
                                </div>
                              }
                              @if (productEntry?.product?.orderable==true && productEntry?.product?.soldOut==false && productEntry?.product?.shipNow=='OFF') {
                                <div class="row verify-step-influenza mt-2"
                                  >
                                  <div class="col-md-12 col-sm-12 p0 pl15">
                                    <p>
                                      <span>Estimated ship date</span>
                                      <span class="req-date">TBD</span>
                                    </p>
                                  </div>
                                </div>
                              }
                            </div>
                            <div class="col-xs-6 col-sm-2 col-md-2 col-lg-3 prd-prc-st3">
                              <div class="product-price">
                                <h6 class="pl">{{'selectVaccines.yourPrice'|cxTranslate}}</h6>
                                <!--You price shown outside is basically after reducing online and direct savings as checked in stage-->
                                <span class="pl">{{(productEntry?.totalPrice?.value
                                  -getPositveNumber(productEntry?.sim_other_discount?.value)
                                  -getPositveNumber(productEntry?.sim_site_discount?.value))
                                  | currency : 'USD' : 'symbol' :'1.2-2'}}
                                </span>
                                <p class="pl">
                                  <a title="view" class="change-loc view-savings" [ngbPopover]=viewSavings placement="top"
                                    #s3="ngbPopover" triggers="manual" popoverClass="savedordermini-popover"
                                  (click)="togglePopover(s3)">{{'selectVaccines.viewSaving'|cxTranslate}}</a>
                                </p>
                                <h6 class="pl prmpt">{{'selectVaccines.pricePrompt'|cxTranslate}}</h6>
                                <h5 class="pl">{{(productEntry?.totalPrice?.value -
                                  getPositveNumber(productEntry?.sim_site_discount?.value) -
                                  getPositveNumber(productEntry?.sim_other_discount?.value) -
                                  getPositveNumber(productEntry?.sim_promptpay_Discount?.value)) | currency : 'USD' :
                                'symbol' : '1.2-2'}}</h5>
                                <ng-template #viewSavings>
                                  <div class="table-responsive">
                                    <table class="view-savings w-100 table">
                                      <thead>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td class="savings-float">{{'selectVaccines.yourPrice'|cxTranslate}}</td>
                                          <td class="text-right" id="single-unit-price">${{productEntry?.totalPrice?.value |
                                          number : '1.2-2'}}</td>
                                        </tr>
                                        <tr>
                                          <td class="savings-float">{{'selectVaccines.directSaving'|cxTranslate}}</td>
                                          <td id="single-direct" class="text-right green">
                                            -{{getPositveNumber(productEntry?.sim_other_discount?.value) | currency : 'USD'
                                          : 'symbol' : '1.2-2'}}</td>
                                        </tr>
                                        <tr>
                                          <td class="savings-float">
                                            {{'selectVaccines.onlineSavings'|cxTranslate}}<sup>2</sup></td>
                                            <td id="single-online" class="text-right green">
                                              -{{getPositveNumber(productEntry?.sim_site_discount?.value) | currency : 'USD' :
                                            'symbol' : '1.2-2'}}</td>
                                          </tr>
                                          <tr class="savings-row">
                                            <td class="ff-bold light-color pt1 savings-float">
                                            {{'selectVaccines.yourPriceSavings'|cxTranslate}}</td>
                                            <td id="single-total" class="ff-bold text-right light-color pt1">
                                              {{(productEntry?.totalPrice?.value -
                                              getPositveNumber(productEntry?.sim_other_discount?.value) -
                                              getPositveNumber(productEntry?.sim_site_discount?.value)) | currency : 'USD' :
                                              'symbol' : '1.2-2'}}
                                            </td>
                                          </tr>
                                          <tr class="prompt-pay">
                                            <td class="savings-float">
                                              {{'selectVaccines.promptPayDiscount'|cxTranslate}}<sup>3</sup></td>
                                              <td id="single-prompt" class="text-right green">
                                                -{{getPositveNumber(productEntry?.sim_promptpay_Discount?.value) | currency :
                                                'USD' : 'symbol' : '1.2-2'}}
                                              </td>
                                            </tr>
                                            <tr class="savings-row">
                                              <td class="ff-bold light-color pt1 savings-float">
                                              {{'selectVaccines.yourPricePay'|cxTranslate}}</td>
                                              <td id="single-prompt-total" class="ff-bold text-right light-color pt1">
                                                {{(productEntry?.totalPrice?.value -
                                                getPositveNumber(productEntry?.sim_other_discount?.value) -
                                                getPositveNumber(productEntry?.sim_site_discount?.value) -
                                                getPositveNumber(productEntry?.sim_promptpay_Discount?.value)) | currency :
                                              'USD' : 'symbol' : '1.2-2'}}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </ng-template>
                                  </div>
                                </div>
                                <div class="col-xs-6 col-sm-3 col-md-3 col-lg-2 px0">
                                  <div class="unitCount-comp">
                                    <div class="addUnits-head bold-12">Units</div>
                                    <div class="add-units">
                                      <span><input type="text" value="{{productEntry?.quantity}}"
                                      class="prodQuantity new-addminus" disabled></span>
                                    </div>
                                    <div class="count-total">
                                      {{
                                      productEntry?.product?.quantityPerUnit *
                                      productEntry?.quantity
                                      }}
                                      {{productEntry?.product?.unit ? productEntry?.product?.unit : 'Doses' }}
                                      <img class="mb-1" src="/icons/confirm.png" />
                                    </div>
                                    @if (productEntry?.product?.orderable==true  && productEntry?.product?.soldOut==true) {
                                      <div class="available-now mt-1"
                                        >
                                        {{productEntry?.product?.soldOutMessageCreate}}
                                      </div>
                                    }
                                    @if (productEntry?.product?.orderable==true  && productEntry?.product?.soldOut==false && productEntry?.product?.shipNow=='ON') {
                                      <div class="available-order mt-1"
                                        >
                                        {{'selectVaccines.available'|cxTranslate}}
                                      </div>
                                    }
                                    @if (productEntry?.product?.orderable==true && productEntry?.product?.soldout==false && productEntry?.product?.waitlist==true && productEntry?.product?.shipNow!='ON') {
                                      <div class="wait-list mt-1"
                                        >
                                        {{'selectVaccines.waitlist'|cxTranslate}}
                                      </div>
                                    }
                                    @if ((editReservation||cancelReservation) && (productEntry?.cancelReasonCode|| productEntry?.reductionReasonCode)) {
                                      <div
                                        class="qtychange">
                                        Quantity change
                                      </div>
                                    }
                                    @if ((editReservation||cancelReservation) && (productEntry?.cancelReasonCode|| productEntry?.reductionReasonCode)) {
                                      <div
                                        class="qtychange-linkCan" [ngbPopover]=popCancelContent [popoverTitle]=popCancelTitle
                                        triggers="manual" #cancelp1="ngbPopover" placement="top" (click)="togglePopover(cancelp1)"
                                        popoverClass="popover-links cancel-popover">
                                        productEntry?.cancelReasonCode? 'Reason for Cancellation' : 'Reason for Reduction'
                                      </div>
                                    }
                                    <ng-template #popCancelTitle>
                                      <span class="text-header">
                                        productEntry?.cancelReasonCode? 'Reason for Cancelling this presentation' : 'Reason for
                                        Reducing this presentation'
                                      </span>
                                    </ng-template>
                                    <ng-template #popCancelContent>
                                      <ng-select class="w-100 popCancelSelect" [items]="cancellationReasons" bindLabel="name"
                                        bindValue="code" [multiple]="false" [clearable]="false" name="chosenCancelReason"
                                        [(ngModel)]="productEntry.chngReason" placeholder="Select Reason" disabled>
                                      </ng-select>
                                      <button type="reset" class="popover-close btn btn-secondary popover-cancel-button"
                                        data-di-id="di-id-d01008be-fb6e135c" (click)="togglePopover(cancelp1)">
                                        Cancel
                                      </button>
                                      <button
                                        class="btn blue-button popover-cancel-button btn-primary popover-cancel-button-submit"
                                        data-di-id="di-id-3064f17d-e97cc628" (click)="togglePopover(cancelp1)">
                                        Save
                                      </button>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </section>

          <section class="list border-b0">
            <div class="row row-20 flu-secpart">
              <div class="col-xs-12 col-sm-7 col-md-6 col-lg-6">
                <ul>
                  <li><sup class="numberflu">1</sup>If applicable, excise tax is
                $0.75 per dose and $7.50 per unit.</li>
                <li><sup class="numberflu">2</sup>Applicable online discount.</li>
                <li><sup class="numberflu">3</sup>Applicable based on contract
              terms.</li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-6 col-lg-6  float-right">
            <p class="units-doses">{{ totalInfluenzaProductsBackend }} {{ "plp.units" | cxTranslate }} &nbsp; | &nbsp;
            {{ totalInfluenzaDosesBackend }} {{ "plp.doses" | cxTranslate }}</p>
          </div>
        </div>
      </section>

      @if (fluLocatorDetail?.showLocatorInFluOrder) {
        <section class="list border-b0">
          <div class="row row-20 flu-secpart">
            <div class="col-12 bgColor fluLocator-container">
              <div class="row">
                <div class="col-12 leftMargin"><span class="EstSavings">We can help your patients find your
                practice!</span>
                <p class="flulocatorTitle">Enroll in our Flu Shot Locator</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12 col-xs-12"><img src="{{imageUrl}}"></div>
              <div class="col-md-6 col-sm-12 col-xs-12">
                <div class="row">
                  <div class="col-12">&nbsp;</div>
                </div>
                <div class="row topMarginCls">
                  <div class="col-12">
                    <p>Have your practice listed on our Flu Shot Locator a free searchable database that lets patients
                      find
                      vaccine providers near them.<br />The listing is optional and you ca manage your preferences at
                      any
                    time</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 leftMargin"><span class="submitstatement">Submit the settings below to be featured in
                the
              locator.</span>
              <p>Please note: Your locations will appear in the locator only if products are
              offered. </p>
            </div>
          </div>
          @if (!removeGrid) {
            <div class="row">
              <div class="col-12 leftMargin">
                <!--table for normal screens, section for mobile devices-->
                <table aria-describedby="locatorTable" id="vaccineLocatorTable" class="inflzTab_table table-striped">
                  <thead>
                    <tr>
                      <th scope="col" class="bgColor_th" style="width: 10%;"
                        (click)="sortColumn($event, 'location', '', 'normal')">
                        Location
                        <i class="my-icon fas fa-caret-down"></i>
                      </th>
                      <th scope="col" class="bgColor_th" style="width: 21%;">
                        Address
                      </th>
                      <th scope="col" class="bgColor_th" style="width: 10%;">
                        Phone
                      </th>
                      <th scope="col" class="bgColor_th" style="width: 10%;">
                        Enroll Status
                      </th>
                      <th scope="col" class="bgColor_th" style="width: 18%;">
                        Product Offered
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (itm of fluLocatorDetail?.fluLocators; track itm) {
                      <tr>
                        <td class="status-txt loc-switch align-baseline loc_stat">
                          <span>
                            {{itm?.customerName}}
                          </span>
                        </td>
                        <td class="status-txt loc-switch align-baseline loc_stat">
                          <span>
                            {{itm?.address}}, {{itm?.city}}, {{"US-"}}{{itm?.state}}, {{itm?.zipcode}}
                          </span>
                        </td>
                        <td class="status-txt loc-switch align-baseline loc_stat">
                          <span>
                            {{itm?.phone}}
                          </span>
                        </td>
                        <td class="status-txt loc-switch align-baseline loc_stat_left">
                          <span class="loc_stat">
                            <label class="switch">
                              @if (itm?.statusId!=2) {
                                <input type="checkbox" class="imCheck" style="display:none;"
                                  (click)="changeEnrollFlag(itm?.locatorId,'enrollflag',false)"
                                  checked>
                              }
                              @if (itm?.statusId==2) {
                                <input type="checkbox" class="imCheck" style="display:none;"
                                  (click)="changeEnrollFlag(itm?.locatorId,'enrollflag',true)">
                              }
                              <span class="slider round"></span>
                            </label>
                            @if (itm?.statusId!=2) {
                              <span>Active</span>
                            }
                            @if (itm?.statusId==2) {
                              <span>Inactive</span>
                            }
                          </span>
                        </td>
                        <td class="status-txt loc-switch align-baseline loc_stat_left">
                          @if (itm?.fluBlockProductId && itm?.fluBlockOptedIn != 'Not Available') {
                            <span>
                              <!--To show toggle if offered or not offered-->
                              @if (itm?.statusId!=2 && itm?.fluBlockOptedIn != 'Not Available') {
                                <label class="switch">
                                  @if (itm?.fluBlockOptedIn=='Offered') {
                                    <input type="checkbox" class="imCheckOptin"
                                      (click)="changeOptInFlag(itm?.locatorId,'fluBlockOptedIn','Not Offered',itm.fluBlockProductId)"
                                      checked>
                                  }
                                  @if (itm?.fluBlockOptedIn!='Offered') {
                                    <input type="checkbox" class="imCheckOptin"
                                      (click)="changeOptInFlag(itm?.locatorId,'fluBlockOptedIn','Offered',itm.fluBlockProductId)"
                                      >
                                  }
                                  <span class="slider round"></span>
                                </label>
                              }
                              <strong>{{itm?.fluBlockProductName}}<span [innerHTML]="itm?.fluBlockProductDesc"></span>
                            ({{itm?.fluBlockProductId}})</strong><br />
                            @if (itm?.fluBlockOptedIn == 'Not Available') {
                              <span>{{itm?.fluZoneOptedIn }}</span>
                            }
                          </span>
                        }
                        @if (itm?.fluZoneProductId && itm?.fluZoneOptedIn != 'Not Available') {
                          <span>
                            @if (itm?.statusId!=2 && itm?.fluZoneOptedIn != 'Not Available') {
                              <label class="switch">
                                @if (itm?.fluZoneOptedIn=='Offered') {
                                  <input type="checkbox" class="imCheckOptin"
                                    (click)="changeOptInFlag(itm?.locatorId,'fluZoneOptedIn','Not Offered',itm.fluZoneProductId)"
                                    checked>
                                }
                                @if (itm?.fluZoneOptedIn!='Offered') {
                                  <input type="checkbox" class="imCheckOptin"
                                    (click)="changeOptInFlag(itm?.locatorId,'fluZoneOptedIn','Offered',itm.fluZoneProductId)"
                                    >
                                }
                                <span class="slider round"></span>
                              </label>
                            }
                            <strong>{{itm?.fluZoneProductName}}<span
                            [innerHTML]="itm?.fluZoneProductDesc"></span>({{itm?.fluZoneProductId}})</strong><br />
                            @if (itm?.fluZoneOptedIn == 'Not Available') {
                              <span>{{itm?.fluZoneOptedIn }}</span>
                            }
                          </span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <!--section for mobile devices-->
              <section id="vaccineLocatorTableSm">
                @for (itm of fluLocatorDetail?.fluLocators; track itm) {
                  <div class="row vaccineLocator-row-table">
                    <ul>
                      <li>
                        <p>Location</p>
                        <p>
                          <span>
                            {{itm?.customerName}}
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>Address</p>
                        <p>
                          <span>
                            {{itm?.address}}, {{itm?.city}}, {{"US-"}}{{itm?.state}}, {{itm?.zipcode}}
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>Phone</p>
                        <p>
                          <span>
                            {{itm?.phone}}
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>Enroll Status</p>
                        <p class="status-txt loc-switch align-baseline loc_stat_left">
                          <span class="loc_stat">
                            <label class="switch">
                              @if (itm?.statusId!=2) {
                                <input type="checkbox" class="imCheck" style="display:none;"
                                  (click)="changeEnrollFlag(itm?.locatorId,'enrollflag',false)"
                                  checked>
                              }
                              @if (itm?.statusId==2) {
                                <input type="checkbox" class="imCheck" style="display:none;"
                                  (click)="changeEnrollFlag(itm?.locatorId,'enrollflag',true)">
                              }
                              <span class="slider round"></span>
                            </label>
                            @if (itm?.statusId!=2) {
                              <span>Active</span>
                            }
                            @if (itm?.statusId==2) {
                              <span>Inactive</span>
                            }
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>Product Offered</p>
                        <p class="status-txt loc-switch align-baseline loc_stat_left">
                          @if (itm?.fluBlockProductId && itm?.fluBlockOptedIn != 'Not Available') {
                            <span>
                              <!--To show toggle if offered or not offered-->
                              @if (itm?.statusId!=2 && itm?.fluBlockOptedIn != 'Not Available') {
                                <label class="switch">
                                  @if (itm?.fluBlockOptedIn=='Offered') {
                                    <input type="checkbox" class="imCheckOptin"
                                      (click)="changeOptInFlag(itm?.locatorId,'fluBlockOptedIn','Not Offered',itm.fluBlockProductId)"
                                      checked>
                                  }
                                  @if (itm?.fluBlockOptedIn!='Offered') {
                                    <input type="checkbox" class="imCheckOptin"
                                      (click)="changeOptInFlag(itm?.locatorId,'fluBlockOptedIn','Offered',itm.fluBlockProductId)"
                                      >
                                  }
                                  <span class="slider round"></span>
                                </label>
                              }
                              <strong>{{itm?.fluBlockProductName}}<span [innerHTML]="itm?.fluBlockProductDesc"></span>
                            ({{itm?.fluBlockProductId}})</strong><br />
                            @if (itm?.fluBlockOptedIn == 'Not Available') {
                              <span>{{itm?.fluZoneOptedIn }}</span>
                            }
                          </span>
                        }
                        @if (itm?.fluZoneProductId && itm?.fluZoneOptedIn != 'Not Available') {
                          <span>
                            @if (itm?.statusId!=2 && itm?.fluZoneOptedIn != 'Not Available') {
                              <label class="switch">
                                @if (itm?.fluZoneOptedIn=='Offered') {
                                  <input type="checkbox" class="imCheckOptin"
                                    (click)="changeOptInFlag(itm?.locatorId,'fluZoneOptedIn','Not Offered',itm.fluZoneProductId)"
                                    checked>
                                }
                                @if (itm?.fluZoneOptedIn!='Offered') {
                                  <input type="checkbox" class="imCheckOptin"
                                    (click)="changeOptInFlag(itm?.locatorId,'fluZoneOptedIn','Offered',itm.fluZoneProductId)"
                                    >
                                }
                                <span class="slider round"></span>
                              </label>
                            }
                            <strong>{{itm?.fluZoneProductName}}<span
                            [innerHTML]="itm?.fluZoneProductDesc"></span>({{itm?.fluZoneProductId}})</strong><br />
                            @if (itm?.fluZoneOptedIn == 'Not Available') {
                              <span>{{itm?.fluZoneOptedIn }}</span>
                            }
                          </span>
                        }
                      </p>
                    </li>
                  </ul>
                </div>
              }
            </section>
          </div>
        </div>
      }
      @if (!removeGrid) {
        <div class="row">
          <div class="col-12 leftMargin cenAl"><button class="btn btn-primary" (click)="submitenrollment()">
          &nbsp;Submit enrollment&nbsp;</button>
        </div>
      </div>
    }
    @if (removeGrid) {
      <div class="row margBottom">
        <div class="col-12">
          <div id="flu_success_msg1" class="cart_value_added">
            <img src="/icons/confirmation-positive-green.png">
            <span>
            All set! We have saved your information.</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>
</section>
}
</section>

<aside id="reserveContact" class="col-lg-4 col-md-12 col-sm-12 col-xs-12 right-navigation float-right ready-to-res">
  <!--Total Esitimation div-->
  <div class="row">
    <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
      <div class="background-grey">
        <span>{{ totalInfluenzaProductsBackend }} {{ "plp.units" | cxTranslate }} &nbsp; | &nbsp; {{
        totalInfluenzaDosesBackend }} {{ "plp.doses" | cxTranslate }}</span>
        <div class="orderTitleSticky">
          Estimated Total:
          <span>
            {{ (totalWithPromptDisc + promptPayDiscount) | currency : 'USD' : 'symbol' : '1.2-2' }}
          </span>
        </div>

        <p class="promptPayMargin">(With Prompt Pay Discount)</p>
        <p><span class="EstSavings">Estimated Savings:</span>
        <span class="green_Savings">{{ getPositveNumber(estimatedSavings) | currency : 'USD' : 'symbol' : '1.2-2'
        }}</span>
      </p>
    </div>

  </div>
</div>

<!--Payment method div-->
<div [class.payMethod-marTop]="isSticky">
  <app-payment-method [orderFlu]="true" [stdCartType]="false" [paymentMethod]="standardCartDetails?.paymentMethod"
    [cancelFluReservation]="true" [cardDetails]="cardDetails"
    (selectedPaymentMethodEvent)="selectedPaymentMethodDetails=$event"
  (selectedCardOAcctDetailsEvent)="selectedCardOrAccountDetails=$event"></app-payment-method>
</div>

<!--Reservation contact edit div-->
<ng-template #reservationContact>

  <p class="text-center mb-2 reservationContactText">Your reservation contact details and receiving hours must be
  accurate to ensure delivery</p>
  <div class="units-doses text-center">
    <a style="background: url('/icons/{{baseSiteId}}/editIcon.png') 0 0/17px no-repeat padding-box;"
    class="edit-icon dismiss" (click)="togglePopover(Dismiss)">Dismiss</a>
  </div>
</ng-template>
<div class="reserve-contact" id="orderConfirmation">
  <div class="row">
    <div class="cold-md-8">
      <span class="sectionTitle" [ngbPopover]="reservationContact" triggers="manual" placement="top"
        #Dismiss="ngbPopover" #reservationContactSpan (click)="togglePopover(Dismiss)"
      popoverClass="verify-popover">Reservation Contact</span>
    </div>
    <div class="col-md-2">&nbsp;</div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <p class="formLabel">This is who we'll contact for ongoing updates about this reservation</p>
    </div>
  </div>

  <!-- Using place order response instead of order contact details api response to display data
  Also there is no edit option in confirmation page-->

  <!--1. NAME -->

  <div class="row">
    <div class="col-md-2 formLabel">Name</div>
    <div class="col-md-8 formValue">{{standardCartDetails?.orderContactData?.name}}</div>
  </div>

  <!--2. Phone-->
  <div class="row">
    <div class="col-md-2 formLabel">Phone</div>
    <div class="col-md-8 formValue">{{standardCartDetails?.orderContactData?.phoneNo}}</div>
  </div>

  <!--3. Mobile-->
  <div class="row">
    <div class="col-md-2 formLabel">Mobile</div>
    <div class="col-md-8 formValue">{{standardCartDetails?.orderContactData?.mobileNo}}</div>
  </div>
  @if (standardCartDetails?.orderContactData?.additionalMobiles?.length > 0) {
    @for (mob of standardCartDetails?.orderContactData?.additionalMobiles; track mob) {
      <div class="row">
        <div class="col-md-2 formLabel"></div>
        <div class="col-md-8 formValue">{{mob}}</div>
      </div>
    }
  }

  @if (standardCartDetails?.orderContactData?.email) {
    <div class="row">
      <div class="col-md-2 formLabel">Email</div>
      <div class="col-md-8 formValue">
        <a class="reservation_email"
        href="mailto:{{standardCartDetails?.orderContactData?.email}}">{{standardCartDetails?.orderContactData?.email}}</a>
      </div>
    </div>
  }
  @if (standardCartDetails?.orderContactData?.additionalEmails?.length > 0) {
    @for (email of standardCartDetails?.orderContactData?.additionalEmails; track email) {
      <div class="row">
        <div class="col-md-2 formLabel"></div>
        <div class="col-md-8 formValue">
          <a class="reservation_email" href="mailto:{{email}}">{{email}}</a>
        </div>
      </div>
    }
  }

  @if (standardCartDetails?.orderContactData?.fax) {
    <div class="row">
      <div class="col-md-2 formLabel">Fax</div>
      <div class="col-md-8 formValue">{{standardCartDetails?.orderContactData?.fax}}</div>
    </div>
  }

  <div class="row">
    <div class="col-md-2 formLabel">Placed By</div>
    <div class="col-md-8 formValue">{{standardCartDetails?.orderContactData?.placedBy ?
    standardCartDetails?.orderContactData?.placedBy : standardCartDetails?.orderContactData?.name}}</div>
  </div>

  <!--For sales rep - extra email shown-->
  @if (isAsmUser && standardCartDetails?.orderContactData?.salesRepEmail) {
    <div class="row">
      <div class="col-md-2 formLabel">Email</div>
      <div class="col-md-8 formValue">
        <a class="reservation_email" href="mailto:{{standardCartDetails?.orderContactData?.salesRepEmail}}">
          {{standardCartDetails?.orderContactData?.salesRepEmail}}
        </a>
      </div>
    </div>
  }
  <div class="row" style="margin-top:5px;">
    <div class="col-xs-6 col-sm-6 col-md-5 formLabel billAddress-title">Billing Address</div>
    <div class="col-xs-6 col-sm-6 col-md-5 formLabel payAddress-title">Payer Address</div>
  </div>
  <div class="row" style="margin-top:5px;">
    @if (standardCartDetails?.shipToParty?.billingAddress) {
      <div class="col-xs-6 col-sm-6 col-md-5 formValue billAddress"
        >
        {{standardCartDetails?.shipToParty?.billingAddress?.accountNumber}}<br />
        @if (standardCartDetails?.shipToParty?.billingAddress?.companyName) {
          <span
          >{{standardCartDetails?.shipToParty?.billingAddress?.companyName}}<br /></span>
        }
        {{standardCartDetails?.shipToParty?.billingAddress?.formattedAddress}}
      </div>
    }
    @if (standardCartDetails?.shipToParty?.payerAddress) {
      <div class="col-xs-6 col-sm-6 col-md-5 formValue soldToAddress"
        >
        {{standardCartDetails?.shipToParty?.payerAddress?.accountNumber}}<br />
        @if (standardCartDetails?.shipToParty?.payerAddress?.companyName) {
          <span
          >{{standardCartDetails?.shipToParty?.payerAddress?.companyName}}<br /></span>
        }
        {{standardCartDetails?.shipToParty?.payerAddress?.formattedAddress}}
      </div>
    }
  </div>
  <div class="row ml-2"><span class="formValue green-undrln" (click)="redirecttoAccount()">Manage billing
  Information</span></div>
</div>
<!--Receiving hours edit div-->
<div class=" row delivery-timings-section">
  <div class="col-md-12">
    <app-receiving-hours [fromModule]="contentModule" (EditVal)="EditValFunc($event)"
    (update)="triggerFunc($event)" [deliveryTimings]="delHrs" [disableEdit]="true"></app-receiving-hours>
  </div>

</div>
</aside>
</div>

</div>
